import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import { CkeditorConfig, CkeditorLightToolbar } from '@/Editor/Components/CKEditor/ckeditor.config';

export const WysiwygEditor = function WysiwygEditor({
  width,
  height,
  properties,
  styles,
  setExposedVariable,
  generateOneTimeToken,
}) {
  const { visibility, disabledState } = styles;
  const { placeholder, defaultValue, apiUrl, lightVersion } = properties;
  const [content, setContent] = useState(defaultValue ?? '');
  const [editor, setEditor] = useState(null);

  const beforeImageUpload = async () => {
    const ret = await generateOneTimeToken('beforeImageUpload');

    return ret?.data || '';
  };

  let uploadAdapterConfig = {
    apiUrl: apiUrl,
    beforeUploadCallback: beforeImageUpload,
  };

  let ckeditorSettings = CkeditorConfig;
  if (lightVersion) {
    ckeditorSettings = { ...ckeditorSettings, toolbar: CkeditorLightToolbar };
  }

  const config = {
    ...ckeditorSettings,
    placeholder: placeholder,
    uploadAdapter: uploadAdapterConfig,
  };

  useEffect(() => {
    setExposedVariable('value', content);
  }, [content]);

  useEffect(() => {
    changeEditorOptions(editor);
  }, [width, height]);

  useEffect(() => {
    if (editor) {
      disabledState ? editor.enableReadOnlyMode('lock') : editor.disableReadOnlyMode('lock');
    }
  }, [disabledState]);

  const changeEditorOptions = (editor) => {
    if (editor) {
      disabledState ? editor.enableReadOnlyMode('lock') : editor.disableReadOnlyMode('lock');
      editor.editing.view.change((writer) => {
        writer.setStyle('height', `${height - 75}px`, editor.editing.view.document.getRoot());
        writer.setStyle('width', `${width}px`, editor.editing.view.document.getRoot());
      });
    }
  };

  useEffect(() => {
    setContent(defaultValue);
  }, [defaultValue]);

  function handleChange(event, editor) {
    setContent(editor.getData());

    setExposedVariable('value', content);
  }

  return (
    <div style={{ width: `${width}px`, height: `${height}px`, display: visibility ? '' : 'none' }}>
      {config ? (
        <CKEditor
          editor={ClassicEditor}
          config={config}
          onChange={handleChange}
          data={content}
          onReady={(editor) => {
            setEditor(editor);
            changeEditorOptions(editor);
          }}
        />
      ) : null}
    </div>
  );
};
